import PropTypes from 'prop-types'
import { graphql } from 'gatsby'

import heroImage from '~media/industries/finance/hero.svg'
import iconDifferentiate from '~media/industries/finance/differentiate.svg'
import iconTest from '~media/industries/finance/test.svg'
import iconUpgrade from '~media/industries/finance/upgrade.svg'
import iconSavings from '~media/industries/finance/savings.svg'
import whitepaper from '~media/industries/finance/whitepaper.png'
import { UseCases } from '~components/industries/UseCases'
import FilteredContent from '~components/FilteredContent'
import IndustryHero from '~components/industries/IndustryHero'
import IndustryTopCTA from '~components/industries/IndustryTopCTA'
import IndustryLayout from '~components/industries/IndustryLayout'

/**
 * @NOTE This page is a dupe of `pages/gcpfinserv` without an added Marketo form
 */

const getIcon = (icon) => {
  // eslint-disable-next-line default-case
  switch (icon) {
    case 'differentiate':
      return iconDifferentiate
    case 'test':
      return iconTest
    case 'upgrade':
      return iconUpgrade
    case 'savings':
      return iconSavings
  }
}

const Finance = ({
  data: {
    file: {
      childMdx: { frontmatter: pageData },
    },
  },
}) => (
  <IndustryLayout
    title={pageData.title}
    description={pageData.description}
    socialMediaImage={pageData.socialMediaImage}
  >
    <IndustryHero
      image={heroImage}
      heading={pageData.hero.heading}
      blurb={pageData.hero.blurb}
      seoRef="finance"
    />
    <IndustryTopCTA
      image={whitepaper}
      heading={pageData.financeWhitepaper.heading}
      cta={pageData.financeWhitepaper.cta}
    />
    <UseCases
      heading={pageData.financeUseCases.heading}
      blurb={pageData.financeUseCases.blurb}
      useCases={pageData.financeUseCases.items}
      getIcon={getIcon}
    />
    <FilteredContent
      heading={pageData.financeDiscover.heading}
      filters="topics:Finance"
    />
  </IndustryLayout>
)

Finance.propTypes = {
  data: PropTypes.object.isRequired,
}

export default Finance

export const pageQuery = graphql`
  query FinancePageData {
    file(
      name: { eq: "industries__finance" }
      absolutePath: { regex: "/src/data/" }
    ) {
      childMdx {
        frontmatter {
          title
          description
          socialMediaImage
          hero {
            blurb
            heading
          }
          financeWhitepaper {
            heading
            cta {
              label
              url
            }
          }
          financeUseCases {
            heading
            blurb
            items {
              heading
              icon
              examples {
                blurb
              }
            }
          }
          financeDiscover {
            heading
          }
        }
      }
    }
  }
`
